<script lang="ts">
      import { goto } from '$app/navigation'
      import { getBodyContext } from '$lib/components/context/ts/BodyContext.svelte'
      import { getPayloadContext } from '$lib/components/context/ts/PayloadGlobals.svelte'
      import Close from '$lib/components/ui/Close.svelte'
      import { tick } from 'svelte'
      import MenuButtonItem from './MenuButtonItem.svelte'
      import MenuButtonSubmenu from './MenuButtonSubmenu.svelte'
      import LocaleSwitcher from '$lib/components/locale/LocaleSwitcher.svelte'

      async function closeMenu(ev: Event) {
            ev.preventDefault()
            //body.closeWithoutBack()

            if (!ev.target) return
            const target = ev.target as HTMLAnchorElement
            const href = target.getAttribute('href') ?? ''
            if (!href) return

            body.closeAndGoto(href)
      }

      let menu: HTMLDivElement

      const body = getBodyContext()

      let visible = $derived(body.opened)
      const payload = getPayloadContext()

      let items = $derived(payload.localizedNavigation)
</script>

<div bind:this={menu} class="menu {visible ? 'open' : ''} w-full h-full fixed fixed-element top-0 left-0 overflow-hidden font-[300]">
      <div class="absolute right-0 h-full gap-3 bg-[#ffffff] flex flex-col justify-start items-end text-xl md:text-xl w-[16rem]">
            <!--<button class="hover:cursor:opacity-100 active:opacity-100 opacity-65" onclick={toggleMenu}>
              <Close class="h-6 my-4"></Close>
        </button>-->
            <div class="w-full flex flex-col items-end justify-center pb-8">
                  {#each items as item, i (i)}
                        <div class="px-2 flex items-start w-full p-2">
                              {#if item.type == 'link'}
                                    <MenuButtonItem onclick={closeMenu} class="hover:cursor:opacity-100 active:opacity-100 opacity-65 " {item}></MenuButtonItem>
                              {:else if item.type == 'internal'}
                                    <MenuButtonItem onclick={closeMenu} class="hover:cursor:opacity-100 active:opacity-100 opacity-65 " {item}></MenuButtonItem>
                              {:else if item.type == 'menu'}
                                    <MenuButtonSubmenu onclick={closeMenu} {item} class=""></MenuButtonSubmenu>
                              {/if}
                        </div>
                  {/each}
                  <div class="flex items-center relative justify-center opacity-65 hover:opacity-100 mr-auto ml-[0.4rem]">
                        <div class="absolute w-full h-[80%] mt-[0.07rem] border-[1px] border-black rounded-full top-0 left-0"></div>
                        <LocaleSwitcher class="px-3 py-[0.4rem]"></LocaleSwitcher>
                  </div>
            </div>
      </div>
</div>

<style lang="postcss">
      .menu {
            transition:
                  left 0.6s ease-in-out,
                  transform 0.6s ease-in-out;
            transform: translateX(16rem);
      }

      .menu:global(.open) {
            transform: translateX(0rem);
      }
</style>
